<template>
    <div>
        <div v-if="selectedToken" class="mb-4">Filter: {{selectedToken}}</div>
        <DataTable :value="preparedDeals" selectionMode="single" dataKey="token" class="p-datatable-sm">
            <Column header="Токен" field="token" ></Column>
            <Column header="Группа" field="group_token" ></Column>
            <Column header="Направление" field="direction" ></Column>
            <Column header="Вход" >
                <template #body="slotProps">
                    {{short_timezoned(slotProps.data.started_at)}}
                </template>
            </Column>
<!--            <Column header="Цена" field="rate_started" ></Column>-->
            <Column header="Причина" field="start_reason" ></Column>

            <Column header="Выход" >
                <template #body="slotProps">
                    <span v-if="slotProps.data.completed_at">{{short_timezoned(slotProps.data.completed_at)}}</span>
                </template>
            </Column>
<!--            <Column header="Цена" field="rate_completed" ></Column>-->
            <Column header="Причина" field="complete_reason" ></Column>
            <Column header="Длит. в часах">
                <template #body="slotProps">
                    <div v-if="slotProps.data.open_minutes">{{Math.floor(slotProps.data.open_minutes/60)}}</div>
                    <div v-else>{{ durationMinutes(slotProps.data.started_at, currentDate)}}</div>
                </template>
            </Column>
            <Column header="%" field="percent_profit" >
                <template #body="slotProps">
                    <div v-if="slotProps.data.percent_profit">
                        <div v-if="slotProps.data.percent_profit < 1" v-html="round_red(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                        <div v-else v-html="round_green(100*slotProps.data.percent_profit, 2, '', '%')"></div>
                    </div>
                </template>
            </Column>
            <Column header="Профит" field="value_profit" >
                <template #body="slotProps">
                    <div v-if="slotProps.data.value_profit">
                        <div v-html="round_colored(slotProps.data.value_profit, 2)"></div>
                    </div>
                    <div v-else>
                        <div v-if="slotProps.data.direction === 'long'" class="text-gray-500">{{round(currentPrice - slotProps.data.rate_started, 2)}}</div>
                        <div v-if="slotProps.data.direction === 'short'" class="text-gray-500">{{round(slotProps.data.rate_started - currentPrice, 2)}}</div>
                    </div>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import helperMethods from '@/helpers';

export default {
    components:{
        DataTable,
        Column
    },
    props:{
        deals: Array,
        currentPrice: String,
        currentDate: String,
        selectedToken: String|null
    },
    data(){
        return {

        }
    },
    methods:{
        ...helperMethods,
        durationMinutes(dateStart, dateEnd){
            // console.log("dateStart", dateStart);
            // console.log("dateStart class", new Date(dateStart));
            // console.log("dateEnd", dateEnd);
            // console.log("dateEnd class", new Date(dateEnd));
            // console.log("diff", new Date(dateEnd) - new Date(dateStart));
            let diffInHours = Math.floor((new Date(dateEnd) - new Date(dateStart)) / 1000 / 60 / 60);
            return diffInHours;
        }
    },
    computed:{
        preparedDeals(){
            if(this.selectedToken) this.deals.filter(deal => deal.token === this.selectedToken);
            else return this.deals;
            // let preparedDeals = [];
            // this.deals.forEach(deal => {
            //     if( deal.group_token === "" || deal.token === deal.group_token){
            //         preparedDeals.push(deal);
            //         this.deals.filter(deal2 => deal2.group_token === deal.token).forEach(deal2 => {
            //             preparedDeals.push(deal2);
            //         });
            //     }
            // });
            // console.log(preparedDeals);
            // return preparedDeals;
        },
    }
}
</script>
